/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { organizationRemoteSessionIssuersListEMAServices } from "../funcs/organizationRemoteSessionIssuersListEMAServices.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListEMAServicesResult } from "../models/components/listemaservicesresult.js";
import {
  ListOrganizationRemoteSessionIssuerEMAServicesRequest,
  ListOrganizationRemoteSessionIssuerEMAServicesSecurity,
} from "../models/operations/listorganizationremotesessionissueremaservices.js";
import { unwrapAsync } from "../types/fp.js";
export type OrganizationRemoteSessionIssuerEMAServicesQueryData =
  ListEMAServicesResult;

export function prefetchOrganizationRemoteSessionIssuerEMAServices(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListOrganizationRemoteSessionIssuerEMAServicesRequest | undefined,
  security?: ListOrganizationRemoteSessionIssuerEMAServicesSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildOrganizationRemoteSessionIssuerEMAServicesQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildOrganizationRemoteSessionIssuerEMAServicesQuery(
  client$: GramCore,
  request?: ListOrganizationRemoteSessionIssuerEMAServicesRequest | undefined,
  security?: ListOrganizationRemoteSessionIssuerEMAServicesSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<OrganizationRemoteSessionIssuerEMAServicesQueryData>;
} {
  return {
    queryKey: queryKeyOrganizationRemoteSessionIssuerEMAServices({
      gramSession: request?.gramSession,
    }),
    queryFn: async function organizationRemoteSessionIssuerEMAServicesQueryFn(
      ctx,
    ): Promise<OrganizationRemoteSessionIssuerEMAServicesQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(organizationRemoteSessionIssuersListEMAServices(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyOrganizationRemoteSessionIssuerEMAServices(
  parameters: { gramSession?: string | undefined },
): QueryKey {
  return [
    "@gram/client",
    "organizationRemoteSessionIssuers",
    "listEMAServices",
    parameters,
  ];
}
